const carRental = {
  carRental: "รถเช่า", // translated
  carRentals: "รถเช่า", // translated
  pickUpPoint: "จุดรับของ", // translated
  dropOffPoint: "จุดลงรถ", // translated
  pickUpDate: "วันที่รับรถ", // translated
  dropOffDate: "วันที่ส่งรถ", // translated
  pickUp: "หยิบ", // translated
  dropOff: "หย่อนลงไปทิ้งลงไป", // translated
  edit: "แก้ไข", // translated
  fuelPolicy: "นโยบายน้ำมันเชื้อเพลิง", // translated
  pickUpLocation: "สถานที่รับรถ", // translated
  mileage: "ระยะทาง", // translated
  transmission: "การแพร่เชื้อ", // translated
  airCondition: "เครื่องปรับอากาศ", // translated
  minimumAge: "อายุขั้นต่ำ", // translated
  maximumAge: "อายุสูงสุด", // translated
  providerAddress: "ที่อยู่ของผู้ให้บริการ", // translated
  providerPhone: "โทรศัพท์ของผู้ให้บริการ", // translated
  driverInfo: "ข้อมูลไดร์เวอร์", // translated
  driversInfo: "ข้อมูลผู้ขับขี่", // translated
  differentDropOff: "รถไปส่งที่จุดอื่น", // translated
  maxPassengers: "ผู้โดยสารสูงสุด", // translated
  budget: "คะแนน", // translated
  provider: "ผู้ให้บริการ", // translated
  carModel: "รุ่นรถ", // translated
  numOfDoors: "จำนวนประตู", // translated
  fuelType: "ประเภทเชื้อเพลิง", // translated
  driverAge: "อายุของผู้ขับขี่", // translated
  workingHours: "ชั่วโมงทำงาน", // translated
  driverNationality: "สัญชาติของผู้ขับขี่", // translated
  carRentalRate: "อัตราค่าเช่ารถ", // translated
  dueNow: "ครบกำหนดตอนนี้", // translated
  duePickUp: "ครบกำหนด ณ จุดรับสินค้า", // translated
  toViewOfferPDF: "หากต้องการดูเอกสาร PDF ที่มีเงื่อนไขการเช่าทั้งหมดของข้อเสนอนี้ โปรด", // translated
  toViewTermsAndCondPDF: "หากต้องการดูข้อกำหนดและเงื่อนไขที่เกี่ยวข้องของ CARNECT โปรด", // translated
};


export default carRental;
